import { defineStyleConfig } from "@chakra-ui/react";

const Button = defineStyleConfig({
  // The styles all button have in common
  baseStyle: {
    fontFamily: "heading",
    borderRadius: "xl",
  },
  variants: {
    overridable: {},
    solid: {
      background: "primary.300",
      color: "primary.100",
      height: 14,
      _hover: {
        color: "primary.300",
        background: "transparent",
        border: "solid 1px var(--chakra-colors-primary-300)",
      },
      _active: {
        background: "primary.300",
        color: "primary.100",
        opacity: .5
      }
    },
    light: {
      background: "primary.100",
      fontFamily: "heading",
      color: "secondary.100",
      height: 14,
      _hover: {
        background: "secondary.300",
        color: "primary.100",
      },
    },
    outline: {
      fontFamily: "heading",
      borderWidth: 2,
      borderColor: "primary.300",
      color: "primary.300",
      height: 14,
      _hover: {
        background: "primary.300",
        color: "primary.100",
        _disabled: {
          background: "primary.300",
          color: "primary.100",
        },
      },
    },
    outlineLight: {
      fontFamily: "heading",
      borderWidth: 2,
      borderColor: "primary.100",
      color: "primary.100",
      height: 14,
      _hover: {
        borderColor: "primary.100",
        color: "secondary.100",
        background: "primary.100",
      },
    },
    base: {
      background: "secondary.500",
      color: "secondary.200",
      borderRadius: "xl",
      height: 14,
      _hover: {
        background: "secondary.500",
        color: "secondary.50",
      },
    },
    ghost: {
      fontFamily: "heading",
    },
    link: {
      fontFamily: "heading",
    },
  },
  defaultProps: {
    colorScheme: "secondary",
  },
});

export default Button;
